module.exports = __webpack_public_path__ + "static/media/seat-bg.8eefe898.png";